<template>
  <div>
    <div class="app-title">
      <em-view-title></em-view-title>
    </div>
    <section class="app-content">
      <el-row :gutter="2">
        <el-col :span="5">
          <el-date-picker
              v-model="searchDate"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
          <em-z-tree :treeNodes="mstLocationList" @onclick="setMstLocationId"></em-z-tree>
        </el-col>
        <el-col :span="19">
          <div id="emMaMaintenanceScheduleResultTable" class="content">
            <el-calendar v-model="searchDate">
              <template v-slot:dateCell="{date, data}">
                <p :class="data.isSelected ? 'is-selected' : ''">
                  <!--                  {{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : '' }}-->
                  {{ data.day.split('-')[2] }}
                  {{ getShiftOfDay(data.day) }}
                  {{ data.isSelected ? '✔️' : '' }}
                </p>
                <div v-if="hasResult(data.day)">
                  {{ getBaseWorkHourOfDay(data.day) }}
                </div>
                <ol v-if="hasResult(data.day)">
                  <li v-for=" (orderId) in getResult(data.day).orderIdList" :key="`${data.day}-${orderId}`">{{
                      orderId
                    }}
                  </li>
                </ol>
              </template>
            </el-calendar>
          </div>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script>
// 排班情况
// Author YuJiaBei
// Date 2020-09-22 07:20:04

import EmViewTitle from "@/components/em/EmViewTitle";
import EmFilterTree from "@/components/em/EmFilterTree";
import EmZTree from "@/components/em/EmZTree";
import EmCommonApi from "@/mixin/em/common/api";
import moment from "moment";

export default {
  name: "sithMesMstShiftCalendar",
  components: {EmViewTitle, EmFilterTree, EmZTree},
  mixins: [EmCommonApi],
  data() {
    return {
      treeEntity: "sithMesMstLocation",
      mstLocationId: "",
      searchDate: new Date(),
      lastSearchDate: new Date(),
      mstLocationList: [],
      calendarShiftList: []
    }
  },
  watch: {
    mstLocationId(newValue, oldValue) {
      this.getCalendarShift()
    },
    searchDate(newValue, oldValue) {
      var difValue = Math.abs((this.lastSearchDate - newValue) / (1000 * 60 * 60 * 24));
      //如果和上次查询的时间差大于150天，才重新执行查询，因为后端默认一次查出了上下各150天的数据
      console.log(`相差天数：${difValue}`)
      if (difValue > 150) {
      console.log("执行了查询")
        this.lastSearchDate = newValue
        this.getCalendarShift()
      }
    }
  },
  methods: {
    setMstLocationId(event, treeId, treeNode, clickFlag) {
      this.mstLocationId = treeNode.id;
    },
    hasResult(day) {
      return this.calendarShiftList && this.calendarShiftList !== [] && this.calendarShiftList.some(c => c.dateStr === day)
    },
    getResult(day) {
      return this.hasResult(day) && this.calendarShiftList.find(c => c.dateStr === day)
    },
    getMstLocationList() {
      this.$_emApiMixin_get(this.$_emApiMixin_entityBaseApi(this.treeEntity))
          .then(data => {
            this.mstLocationList = data
          })
    },
    getShiftOfDay(day) {
      if (this.hasResult(day)) {
        let result = this.getResult(day)
        if (result.shiftList && result.shiftList !== []) {
          return `当班：${result.shiftList.join('-')}`
        }
      }
    },
    getBaseWorkHourOfDay(day) {
      if (this.hasResult(day)) {
        let result = this.getResult(day)
        if (result.baseWorkHour) {
          return `工作能力：${result.baseWorkHour}`
        }
      }
    },
    getCalendarShift() {
      const _api = `${this.$_emApiMixin_moduleBaseApi(this.treeEntity)}/sithMesMstCalendarShift/getCalendarShift`
      this.$_emApiMixin_post(_api, {
            mstLocationId: this.mstLocationId,
            queryDate: moment(this.searchDate).format(
                // this.$store.getters["userPreferences/getDateTimeString"]
                this.$t("em.datetime.format.viewMode")
            )
          }
      ).then(data => {
        this.calendarShiftList = data.data
      })
    }
  }
  ,
  created() {
    this.getMstLocationList()
  }
}
</script>


<style scoped>
.is-selected {
  color: #1989FA;
}
</style>